import { Button, Icon } from '@zillow/constellation-10';
import { IconReloadOutline } from '@zillow/constellation-icons';

type Props = {
  ariaLabel: string;
  onReset: () => void;
};

const ResetButton = ({ ariaLabel, onReset }: Props) => (
  <Button
    aria-label={ariaLabel}
    emphasis="outlined"
    size="sm"
    tone="brand"
    icon={<Icon render={<IconReloadOutline />} />}
    onClick={onReset}
  >
    Reset
  </Button>
);

export default ResetButton;
